export function extractHtmlBlocks(markdownText) {
    const codeBlockPattern = /```(html|css|javascript|js)\n([\s\S]*?)(```|$)/g;


    const result = {
        html: '',
    };

    let match;
    while ((match = codeBlockPattern.exec(markdownText)) !== null) {
        const language = match[1];
        const code = match[2];

        switch (language) {
            case 'html':
                result.html = code;
                break;
        }
    }

    return result;
}

export function getIframeContent(url) {
    return fetch(url)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.text();
        });
}

export function getIframeSrc(text) {
    const match = text.match(/<iframe[^>]*class="[^"]*act-embed[^"]*"[^>]+src="([^"]+)"[^>]*>/);
    return match ? match[1] : null;
}

export function openFiddle(html) {
    const actionURL = 'https://jsfiddle.net/api/post/library/pure/';
    const method = 'POST';
    const formData = {
        html: html,
    };

    createAndSubmitForm(actionURL, method, formData);
};

function createAndSubmitForm(actionURL, method, formData) {
    const form = document.createElement('form');

    form.method = method;
    form.action = actionURL;
    form.target = '_blank';

    for (let key in formData) {
        if (formData.hasOwnProperty(key)) {
            const input = document.createElement('input');
            input.type = 'hidden';
            input.name = key;
            input.value = formData[key];
            form.appendChild(input);
        }
    }

    document.body.appendChild(form);

    form.submit();
}

